import $ from 'jquery';

$('.js-feed').each(function (_, feed) {
  const $feed = $(feed);
  const $feedList = $feed.find('.js-feed-list');
  const $feedItem = $feed.find('.js-feed-item');
  const FEED_ITEM_DURATION = 5000; // ms

  if ($feedItem.length > 1) {
    $feedItem.first().addClass('is-current');
    // Update height
    $feedList.height($feedItem.filter('.is-current').height());
    setInterval(() => {
      // Get current item; remove .is-current
      const $feedItemCurrent = $feedItem
        .filter('.is-current')
        .removeClass('is-current');
      // Add .is-current to next item
      if ($feedItemCurrent.next().length >= 1) {
        $feedItemCurrent.next().addClass('is-current');
      } else {
        $feedItem.first().addClass('is-current');
      }
      // Update height
      $feedList.height($feedItem.filter('.is-current').height());
    }, FEED_ITEM_DURATION);
  }

  if ($feedItem.length === 1) {
    if ($feedItem.hasClass('is-current') !== true) {
      $feedItem.addClass('is-current');
    }
  }
});
